import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { useMemo } from 'react';
import { UseDosiminQueryOptions } from '~/components/Query/Query.hooks';

export type RatesParams = {
  tradeCodeList: string[];
};
export type Rate = {
  baseDateTime: Date;
  price: number;
  tradeCode: string;
};
export type RatesResponse = {
  responseData: Rate[];
};
export const ratesUrl = '/api/stores/citizen/v2/dosi/market/rate';
export const getRates = async (params?: RatesParams) => {
  const {
    data: { responseData: rates },
  } = await axios.get<RatesResponse>(ratesUrl, { params });
  return rates.map((rate) => ({
    ...rate,
    baseDateTime: new Date(rate.baseDateTime),
  }));
};

export const useRates = (params: RatesParams, options?: UseDosiminQueryOptions<Rate[]>) =>
  useQuery<Rate[]>(['rate', params], () => getRates(params), {
    ...options,
    staleTime: 60 * 1000,
  });

export const useRate = (tradeCode: string, options?: UseDosiminQueryOptions<Rate[]>) => {
  const { data, ...rest } = useRates({ tradeCodeList: [tradeCode] }, options);
  const found = useMemo(() => data?.find((d) => d.tradeCode === tradeCode), [data, tradeCode]);

  return {
    data: found,
    ...rest,
  };
};
